import script from "./search-page.vue?vue&type=script&setup=true&lang=js"
export * from "./search-page.vue?vue&type=script&setup=true&lang=js"

import "./search-page.vue?vue&type=style&index=0&id=083189ae&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083189ae"]])

export default __exports__